import { ActionsUnion, createAction } from '../../../redux/customActions';

export const Actions = {
    updateAlcopaAccessRequested: () => createAction('user/updateAlcopaAccessRequested'),
    updateAlcopaAccessFailed: () => createAction('user/updateAlcopaAccessFailed'),
    updateAlcopaAccessSucceeded: () => createAction('user/updateAlcopaAccessSucceeded'),
};

export type ActionsType = ActionsUnion<typeof Actions>;
